import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Logo from 'layouts/subcomponents/Logo'
import styles from 'layouts/DoublePanelViewLayout/DoublePanelViewLayout.module.scss'
import { CloseButton, Content, Header, Side } from 'layouts/DoublePanelViewLayout/subcomponents'
import { Grid } from 'gu-ui-kit'

export const DoublePanelViewLayout = ({
  children = null,
  side = null,
  onClose = () => {},
  contentClassName = '',
  sideContainerClassname = '',
}) => (
  <section className={styles['layout']}>
    <Grid className={styles['layout__content-wrapper']}>
      <Header
        className={clsx(styles['layout__header'], {
          [styles['layout__header_centered']]: !side,
        })}
      >
        <div className={styles['layout__header-wrapper']}>
          <Content
            className={clsx(styles['header__content'], {
              [styles['header__content_centered']]: !side,
            })}
            centered={!side}
          >
            <div className={styles['header__content-wrapper']}>
              <div className={styles['logo']}>
                <Logo />
              </div>
            </div>
          </Content>

          <Side className={clsx(styles['header__side'], sideContainerClassname)}>
            <div className={styles['side-content-wrapper']}>
              <CloseButton onClose={onClose} />
            </div>
          </Side>
        </div>
      </Header>
      <Content
        className={clsx(styles['layout__content'], contentClassName, {
          [styles['layout__content_centered']]: !side,
        })}
      >
        {children}
      </Content>
      {side && <Side className={clsx(styles['layout__side'], sideContainerClassname)}>{side}</Side>}
    </Grid>
  </section>
)

DoublePanelViewLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  side: PropTypes.element,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
  sideContainerClassname: PropTypes.string,
}
